import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
/* eslint-disable */

import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { Chevron } from '@latitude/chevron';
import './_select-list.scss';
let SelectList = /*#__PURE__*/function (_React$Component) {
  function SelectList(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleClick = (index, e) => {
      e.preventDefault();
      _this.selectItem(index);

      // handle onClick event from parent
      if (_this.props.onClick) {
        _this.props.onClick(index, e);
      }
    };
    _this.selectItem = _this.selectItem.bind(_this);
    _this.state = {
      selectedItem: 0
    };
    return _this;
  }
  _inheritsLoose(SelectList, _React$Component);
  var _proto = SelectList.prototype;
  _proto.selectItem = function selectItem(index) {
    this.setState({
      selectedItem: index
    });
  };
  _proto.render = function render() {
    const {
      hideChevron = false
    } = this.props;
    return /*#__PURE__*/React.createElement("ul", {
      className: classnames('select-list"', this.props.className),
      style: this.props.style
    }, this.props.data.map((item, index) => {
      const isActive = this.state.selectedItem === index;
      const className = 'select-list__item ' + (isActive ? 'select-list__item--active ' : ' ');
      return /*#__PURE__*/React.createElement("li", {
        className: className,
        key: index,
        onClick: e => this.handleClick(index, e)
      }, ReactHtmlParser(item), isActive && !hideChevron && /*#__PURE__*/React.createElement(Chevron, {
        direction: "right",
        className: "select-list__chevron"
      }));
    }));
  };
  return SelectList;
}(React.Component);
/* eslint-disable react/forbid-prop-types */
export default SelectList;